const VISIBLE = 'visible';
const HIDDEN = 'hidden';
export const VISIBILITY = {
  visible: VISIBLE,
  hidden: HIDDEN,
};

const SMALL = 'small';
const MEDIUM = 'medium';
export const SIZE = {
  small: SMALL,
  medium: MEDIUM,
};
